import { useState } from 'react';
import TaggableInput from '../TaggableInput.jsx';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const InvoiceActionSettings = ({ settings, setSettings, schema }) => {
    const lineItems = settings?.line_items || [];

    const addLineItem = () => {
        const newLineItems = [
            ...lineItems,
            {
                name: '',
                quantity: 1,
                unit_price: 0,
            },
        ];
        setSettings({ ...settings, line_items: newLineItems });
    };

    const removeLineItem = index => {
        const newLineItems = lineItems.filter((_, idx) => idx !== index);
        setSettings({ ...settings, line_items: newLineItems });
    };

    const updateLineItem = (index, field, value) => {
        const newLineItems = [...lineItems];
        newLineItems[index] = {
            ...newLineItems[index],
            [field]: value,
        };
        setSettings({ ...settings, line_items: newLineItems });
    };

    return (
        <div className="pb-12">
            <div className="input-label">Line Items</div>
            <div className="space-y-4">
                {lineItems.map((item, idx) => (
                    <div
                        key={idx}
                        className="panel p-4 relative"
                    >
                        <button
                            type="button"
                            className="absolute top-2 right-2 text-gray-400 hover:text-red-600"
                            onClick={() => removeLineItem(idx)}
                        >
                            <TrashIcon className="w-5 h-5" />
                        </button>

                        <div className="input-label">Item Name</div>
                        <TaggableInput
                            schema={schema}
                            initialValue={item.name || ''}
                            onChange={value =>
                                updateLineItem(idx, 'name', value)
                            }
                        />

                        <div className="grid grid-cols-2 gap-4 mt-4">
                            <div>
                                <div className="input-label">Quantity</div>
                                <TaggableInput
                                    schema={schema}
                                    initialValue={
                                        item.quantity?.toString() || '1'
                                    }
                                    onChange={value =>
                                        updateLineItem(idx, 'quantity', value)
                                    }
                                />
                            </div>
                            <div>
                                <div className="input-label">Price Per Item</div>
                                <TaggableInput
                                    schema={schema}
                                    initialValue={
                                        item.unit_price?.toString() || '0'
                                    }
                                    onChange={value =>
                                        updateLineItem(idx, 'unit_price', value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <button
                type="button"
                className="btn-light-pill flex items-center mt-4"
                onClick={addLineItem}
            >
                <PlusIcon className="w-4 h-4 mr-2" />
                Add Line Item
            </button>

            <div className="mt-6">
                <label className="flex items-center">
                    <input
                        type="checkbox"
                        checked={settings?.send_immediately || false}
                        onChange={e =>
                            setSettings({
                                ...settings,
                                send_immediately: e.target.checked,
                            })
                        }
                        className="mr-2"
                    />
                    <span>Send invoice immediately (otherwise save as draft)</span>
                </label>
            </div>
        </div>
    );
};

export default InvoiceActionSettings;

